import queryString from 'query-string';
import _ from 'lodash';
import { useStore } from "../useStore";
import {
  resourceIsLoading, resourceItemReceived, resourceItemsReceived, resourceActionReceived
} from '../reducers/crud';
import { fetchRequest } from '../fetch';
import moment from 'moment';

const Crud = ({ resource, children }) => {
  const { state, dispatch } = useStore();
  const resourceState = _.get(state, resource, {});
  return children({
    resource,
    ...resourceState,
    dispatch,
    getItem: (id, params = {}, force = false) => {
      const now = new Date();
      const future = moment(resourceState.itemDate).add(10, 'm').toDate();
      if (!force && resourceState.itemDate && future > now) {
        return;
      }
      dispatch(resourceIsLoading(resource));
      fetchRequest(resource + '/' + id + '/', { method: 'GET' }).then(
        response => (response.json()),
        error => ({ id: 1, title: 'Test' })
      ).then(json => dispatch(resourceItemReceived(resource, json)))
    },
    getItems: ({ ordering = '', filter = {}, ...rest }, force = false) => {
      const now = new Date();
      const future = moment(resourceState.itemsDate).add(10, 'm').toDate();
      if (!force && resourceState.itemsDate && future > now) {
        return;
      }
      dispatch(resourceIsLoading(resource));
      let params = { ...filter };
      if (ordering)
        params.ordering = ordering;
      const qs = queryString.stringify(params);
      const url = `${resource}/${qs ? '?' + qs : ''}`;
      fetchRequest(url, { method: 'GET' }).then(
        response => (response.json()),
        error => ([{ id: 1, title: 'Rådanäs Bourbon Mash Beer 6.7% 24x330ml Bottle', description: 'Denna öl är fin i smaken.', price: 100.00 }, { id: 2, title: 'Rådanäs Black IPA 6.9% 30L KeyKeg', description: 'Denna öl är fin i smaken.', price: 120.00 }])
      ).then(json => dispatch(resourceItemsReceived(resource, json)))
    },
    updateItem: (id, data) => {
      dispatch(resourceIsLoading(resource));
      fetchRequest(resource + '/' + id + '/', { method: 'PUT', body: JSON.stringify(data) }).then(
        response => (response.json()),
        error => ([{ id: 1, title: 'Rådanäs Bourbon Mash Beer 6.7% 24x330ml Bottle' }, { id: 2, title: 'Rådanäs Black IPA 6.9% 30L KeyKeg' }])
      ).then(json => dispatch(resourceItemReceived(resource, json)))
    },
    detailAction: (id, action, data) => {
      dispatch(resourceIsLoading(resource));
      return fetchRequest(`${resource}/${id}/${action}/`, { method: 'POST', body: JSON.stringify(data) }).then(
        response => (response.json()),
        error => ([{ id: 1, title: 'Rådanäs Bourbon Mash Beer 6.7% 24x330ml Bottle' }, { id: 2, title: 'Rådanäs Black IPA 6.9% 30L KeyKeg' }])
      ).then(json => { dispatch(resourceActionReceived(resource, action, json)); return json });

    }
  });
}
export default Crud;
